module.exports = __webpack_public_path__ + "quote_left.7cbdc3665420cbe467c10e0cc568c402.svg";